<div class="row title">
  <span class="ss-text-light rk-activeLink addCursor" routerLink="/"> Dashboard / </span> <span>Testimonial</span>
  <p class="add" data-toggle="tooltip" title="Add Testimonial" data-placement="left" [routerLink]="['/testimonial/create']" routerLinkActive='active'><i class="fa fa-plus" aria-hidden="true"></i></p>
</div>
<div class="row justify-content-center mb-lg-5 mb-4 mt-3">
	<div class="col-11 mt-5">
		<div class="row mt-5">
			<div class="col-md-4" *ngFor="let obj of testimonials">
				<div class="card mb-md-5 mb-sm-3 mb-3 border-0">
					<div class="videoDiv d-flex align-items-center justify-content-center">
						<img id="img_{{ obj.id }}" src="../../assets/img/play-btn.png" width="40px">
						<div class="video" (click)="playVideo(obj.id)">
					    <video id="{{obj.id}}" controlsList="nodownload">
				        <source src="{{ obj.video_url }}#t=1" type="video/mp4" />
					    </video>
						</div>
					</div>
				  <div class="card-body Cbody">
				  	<p class="titleTestimonial">{{ obj.profession}}</p>
				    <p class="card-text paraTestimonial">"{{ obj.testimonial }}"</p>
				    <p class="text-secondary nameTestimonial">{{ obj.name }}</p><span><a (click)="confirmAndDelete(obj.id)"><i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-trash" aria-hidden="true"></i></a>
		            <a [routerLink]="['/testimonial/'+obj.id+'/edit']"><i data-toggle="tooltip" title="Delete" data-placement="top" class="fa fa-pencil" aria-hidden="true"></i></a></span>
				  </div>
				</div>
			</div>			
		</div>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/platform/testimonial/view/view.component.html